import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import HeroSection from './HeroSection';
import ResultsSection from './ResultsSection';
import VitalMethodSection from './VitalMethodSection';
import AboutSection from './AboutSection';
import FAQSection from './FAQSection';
import FreeResourceSection from './FreeResourceSection';
import Footer from './Footer';

const LandingPage = () => {
  const navigate = useNavigate();

  const handleApplyClick = () => {
    navigate('/application');
  };

  return (
    <div className="min-h-screen bg-black">
      <Header onApplyClick={handleApplyClick} />
      
      <main>
        <div id="hero">
          <HeroSection onApplyClick={handleApplyClick} />
        </div>
        <ResultsSection />
        <VitalMethodSection onApplyClick={handleApplyClick} />
        <AboutSection />
        <FAQSection />
        <FreeResourceSection />
      </main>

      <Footer />
    </div>
  );
};

export default LandingPage;
